<template>
  <div class="appHeaderAutorized">
    <div class="authorized" :class="{logout : IS_LOGIN}" v-if="!IS_LOGIN">
      <router-link to="/logIn">
      <span class="imgWrap">
      <img src="../assets/images/login_cn.svg">
        </span>
      </router-link>
    </div>
    <div class="alarm" v-else @click="goPush()">
      <div class="imgWrap">
        <img src="@/assets/images/alarm.svg">
      </div>
      <div class="count mainCount" v-if="getPushCounted >= 1">
        <span class="" ></span>
      </div>
    </div>
    <div class="logo">
      <span class="imgWrap pointer">
        <img src="../assets/images/thanq_logo2.svg"/>
      </span>
    </div>
    <div class="uberButton" @click="uberClick">
        <span class="imgWrap">
            <img src="../assets/images/menu.png"/>
        </span>
    </div>
    <add-popup-header v-if="checkPopupHeader"
                      :popupSet2="popupSet2"/>
  </div>
</template>

<script>
import AddPopupHeader from '@/components/AddPopupHeader'
import { mapMutations, mapState, mapGetters } from 'vuex'
import { getCookie } from '../utils/cookieNew'
// import EventBus from '../utils/bus'
export default {
  data () {
    return {
      popupSet2: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'another',
        nextLink: '/'
      },
      anotherMessage: ''
    }
  },
  computed: {
    ...mapGetters([
      'GET_REFRESH_APPHEADER',
      'IS_LOGIN',
      'GET_USERINFO_LIST'
    ]),
    ...mapGetters('push', [
      'getPushCounted'
    ]),
    ...mapState([
      'checkPopupHeader'
    ])
  },
  created () {
    if ((getCookie('token') !== undefined)) {
      this.userName = getCookie('userName')
    }
  },
  methods: {
    ...mapMutations([
      'SET_POPUP_HEADER',
      'SET_SIDEBAR_OPEN'
    ]),
    refreshMain () {
      window.location.reload()
    },
    uberClick () {
      this.SET_SIDEBAR_OPEN(true)
    },
    popupSetter () {
      this.SET_POPUP_HEADER(true)
      this.popupSet2.content = '로그아웃 되었습니다.'
    },
    goPush () {
      this.$router.push('/pushList')
    }
  },
  components: {
    AddPopupHeader
  }
}
</script>

<style lang="scss" scoped>
</style>
